class Tablist {
  init($el) {
    this.$el = $el;
    this.$tabs = this.$el.querySelectorAll('.js--tablist__tab');
    this.$panels = this.$el.querySelectorAll('.js--tablist__panel');

    this.activateFirst();
    this.handleClickTab();
  }

  activateFirst() {
    // is there an active tab?
    const $filtered = [...this.$tabs].some($tab => $tab.classList.contains('is-active'));
    // if not, set the first one active
    if (!$filtered.length) {
      this.openTab(this.$tabs[0].dataset.panelId);
    }
  }

  handleClickTab() {
    for (let i = 0; i < this.$tabs.length; i += 1) {
      const $tab = this.$tabs[i];

      $tab.addEventListener('click', (e) => {
        this.openTab(e.target.dataset.panelId);
      })
    }
  }

  openTab(id) {
    for (let i = 0; i < this.$tabs.length; i += 1) {
      const $tab = this.$tabs[i];
      if ($tab.classList.contains('is-active')) {
        $tab.classList.remove('is-active');
      }
    }

    for (let i = 0; i < this.$panels.length; i += 1) {
      const $panel = this.$panels[i];
      if ($panel.classList.contains('is-open')) {
        $panel.classList.remove('is-open');
      }

      if ($panel.id === id) {
        $panel.classList.add('is-open');
      }
    }

    const openTab = [...this.$tabs].find($tab => (
      $tab.dataset.panelId === id
    ));

    openTab.classList.add('is-active');
  }
}

[...document.querySelectorAll('.js--tablist')].forEach($el => {
  const inst = new Tablist();
  inst.init($el);
});
